import Actions from 'flow/actions';
import CallRecordsResource from 'flow/api/callrecords';
import RecordedCallsResource from 'flow/api/recordedcalls';
import { networkErrorDispatcher } from 'flow/actions/app-actions';
import { AppDispatch } from 'flow/types/Redux';
import {
    CallRecordKey,
    QueueKey,
    RecordedCallKey,
} from 'flow/types/EntityKeys';

export const triggerExtendedTranscription =
    (recordedCallKey: RecordedCallKey, isPersonal?: boolean) =>
    (dispatch: AppDispatch) => {
        return new Promise<void>((resolve, reject) => {
            RecordedCallsResource.triggerExtendedTranscription(
                {
                    onResult: () => {
                        resolve();
                    },
                    onError: (error: unknown) => {
                        networkErrorDispatcher(dispatch);
                        reject(error);
                    },
                    onClientError: (req: XMLHttpRequest) => {
                        reject({ status: req.status });
                    },
                },
                recordedCallKey,
                isPersonal,
            );
        });
    };

export const fetchExtendedTranscriptionInfo =
    (callRecordKey: CallRecordKey, callRecordQueueKey?: QueueKey) =>
    (dispatch: AppDispatch) => {
        CallRecordsResource.getCallRecord(
            {
                onResult: (response: any) => {
                    const { extendedTranscriptionInfo } = response;
                    if (extendedTranscriptionInfo) {
                        dispatch({
                            type: Actions.SET_EXTENDED_TRANSCRIPTION_INFO,
                            callRecordKey,
                            queueKey: callRecordQueueKey,
                            extendedTranscriptionInfo,
                        });
                    }
                },
            },
            callRecordKey,
            'apps',
        );
    };
